import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";

export default function BlogDetail() {
  const { url } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    api.blog(url)
      .then((data) => { setPost(data); window.scrollTo(0, 0); })
      .catch(() => setNotFound(true));
  }, [url]);

  if (notFound) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-14">
        <Seo title="Not Found" path={`/blogs/${url}`} noindex />
        <div className="text-xs uppercase tracking-widest text-[var(--yp-muted)]">
          <Link to="/">Home</Link> · <Link to="/blogs">Blog</Link>
        </div>
        <h1 className="font-serif-display text-4xl text-[var(--yp-primary)] mt-2">Not found</h1>
        <p className="mt-6 leading-relaxed text-[var(--yp-text)]">This post doesn't exist.</p>
      </div>
    );
  }

  if (!post) return <div className="mx-auto max-w-3xl px-4 py-24 text-center text-[var(--yp-muted)]">Loading post…</div>;

  const date = post.created_at
    ? new Date(post.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
    : "";

  return (
    <div data-testid="blog-detail" className="mx-auto max-w-3xl px-4 py-8 md:py-12">
      <Seo
        title={post.title}
        description={post.excerpt || post.title}
        path={`/blogs/${post.id}`}
        image={post.cover_image}
      />
      <div className="text-xs uppercase tracking-widest text-[var(--yp-muted)]">
        <Link to="/">Home</Link> · <Link to="/blogs">Blog</Link>
      </div>

      {post.cover_image && (
        <div className="mt-4 aspect-[16/9] bg-[var(--yp-surface-alt)] rounded-3xl overflow-hidden">
          <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
        </div>
      )}

      <h1 className="font-serif-display text-3xl md:text-4xl text-[var(--yp-primary)] mt-6">{post.title}</h1>
      {date && <div className="text-sm text-[var(--yp-muted)] mt-2">{date}</div>}

      <div className="blog-content mt-8" dangerouslySetInnerHTML={{ __html: post.body || "" }} />
    </div>
  );
}
